<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn th-btn-normal"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getAddRoute()"
      >
        <span>{{ 'common.add' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ 'plugins.discussion.name' | translate }}</span>
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data">
          <div *ngFor="let message of messages">
            <span innerHtml="{{ message | translate : { value: plugin } }}"></span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content th-content-customer" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-pv3" *ngFor="let comment of comments">
      <table class="ir-plugin-table">
        <tr class="ir-line">
          <td width="90%">
            <div class="ir-plugin-values th-plugin-values">
              <p>
                <span
                  >From : <strong>{{ comment.Writter | personName }}</strong></span
                >
              </p>
            </div>
          </td>
          <td rowspan="2" align="right">
            <div
              *ngIf="currentPerson.id === comment.Writter"
              class="ir-btn th-btn-normal"
              [routerLink]="getEditRoute(comment)"
            >
              <i class="material-icons">edit</i>
            </div>
          </td>
        </tr>
        <tr class="ir-line">
          <td>
            <div class="ir-plugin-values th-plugin-values">
              <p>
                <span
                  >{{ 'plugins.comment.to' | translate }} :
                  <strong>{{
                    comment.Type != -1
                      ? (comment.Type | discussioncommenttype)
                      : ('plugins.customer-comments.select-comment-type' | translate)
                  }}</strong></span
                >
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span>{{ comment.LastModification | formatDate }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span innerHtml="{{ comment.Comment }}"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
